import { getBucketInterval } from 'app/agriculture/queries/snapshots/config/bucketConfig';
import { useTimeZone } from 'app/agriculture/hooks/useTimeZone/useTimeZone';
import { useCallback } from 'react';

export function useDailyRainfallQueryKey() {
    const { timeZone } = useTimeZone();
    const bucketInterval = getBucketInterval(new Date(), { bucketSize: 'day', timeZone });

    const generateDailyRainfallQueryKey = useCallback(
        ({ deviceId }: { deviceId?: string }) =>
            [
                '/snapshots/weather_snapshots/agg/',
                {
                    device_id: deviceId,
                    timestamp_start: bucketInterval.end.toISOString(),
                    timestamp_end: bucketInterval.end.toISOString(),
                    interval: 'day',
                },
            ] as const,
        [bucketInterval],
    );

    return { generateDailyRainfallQueryKey };
}
